module.exports = __webpack_public_path__ + "img/icon-idle.9d6a325f.png";